"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const Contract = __importStar(require("@tableau/api-external-contract-js"));
const api_shared_js_1 = require("@tableau/api-shared-js");
const Workbook_1 = require("./Workbook");
class SheetInfo {
    constructor(_sheetInfoImpl, _workbookImpl) {
        this._sheetInfoImpl = _sheetInfoImpl;
        this._workbookImpl = _workbookImpl;
    }
    get name() {
        return this._sheetInfoImpl.name;
    }
    get sheetType() {
        return this._sheetInfoImpl.sheetType;
    }
    get index() {
        if (this._sheetInfoImpl.index !== undefined) {
            return this._sheetInfoImpl.index;
        }
        throw new api_shared_js_1.TableauError(Contract.EmbeddingErrorCodes.ImplementationError, `index not implemented`);
    }
    get isActive() {
        if (this._sheetInfoImpl.isActive) {
            return this._sheetInfoImpl.isActive;
        }
        return false;
    }
    get isHidden() {
        if (this._sheetInfoImpl.isHidden) {
            return this._sheetInfoImpl.isHidden;
        }
        return false;
    }
    get workbook() {
        return new Workbook_1.Workbook(this._workbookImpl);
    }
    get url() {
        if (this._sheetInfoImpl.url) {
            return this._sheetInfoImpl.url;
        }
        return '';
    }
    get size() {
        if (api_shared_js_1.SheetUtils.isValidSheetSize(this._sheetInfoImpl.sheetSize)) {
            return this._sheetInfoImpl.sheetSize;
        }
        throw new api_shared_js_1.TableauError(Contract.EmbeddingErrorCodes.NotImplemented, 'Not implemented');
    }
}
exports.SheetInfo = SheetInfo;
//# sourceMappingURL=SheetInfo.js.map